/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Billing_RefundInputs */



/**
* | output |
* | --- |
* | "The plan ended after its payment was refunded in full" |
*
* @param {Activity_Billing_RefundInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_billing_refund = /** @type {((inputs?: Activity_Billing_RefundInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Billing_RefundInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тариф завершён: оплата полностью возвращена")
	return /** @type {LocalizedString} */ ("The plan ended after its payment was refunded in full")
});